$(document).ready(
    function () {
        let organizer_email_mailing_ajax_lock = false;
        let p = $("body").attr("p");

        if (p === "organizer_email_mailing" || p === "organizer_email_mailings") {

            $(document).on("submit", "#organizer_email_mailing_form", function () {
                if (!organizer_email_mailing_ajax_lock) {
                    organizer_email_mailing_ajax_lock = true;
              
                    let formData = new FormData(
                      document.getElementById("organizer_email_mailing_form")
                    );

                    $.ajax({
                        type: "POST",
                        url: "/ajax/organizer_email_mailing/update",
                        data: formData,
                        async: true,
                        cache: false,
                        processData: false,
                        contentType: false,
                    })
                    .done(function (data) {
                        if (data.message !== undefined && data.message !== null) {
                            prependAlert(
                                "#div_organizer_email_mailing_form_button",
                                data.message,
                                "success",
                                null,
                                "#organizer_email_mailing_form"
                            );
                            $(".card-box-to-hide").hide();
                            $("#organizer_email_mailing_form_button").hide();

                            setTimeout(function () {
                                document.location.href = "/organizer/settings/email_mailings";
                            }, 3000);
                        }
                    })
                    .fail(function (data) {
                        if (
                        data.responseJSON.redirect_url !== undefined &&
                        data.responseJSON.redirect_url !== null
                        ) {
                        document.location.href = data.responseJSON.redirect_url;
                        }
            
                        if (
                        data.responseJSON.error_message !== undefined &&
                        data.responseJSON.error_message !== null
                        ) {
                        prependAlert(
                            "#div_organizer_email_mailing_form_button",
                            data.responseJSON.error_message,
                            "danger",
                            null,
                            "#organizer_email_mailing_form"
                        );
                        }
            
                        organizer_email_mailing_ajax_lock = false;
                    })
                    .always(function () {
                        organizer_email_mailing_ajax_lock = false;
                    });
                }
                
                return false;
            })

            $(document).on("change", ".custom-control-input[name='send_type']", function () {
                let $input = $("input[name='number_of_days']");
                if ($(this).val() == "3") {
                    $input.attr("min", "0");
                } else {
                    $input.attr("min", "1");
                }
            })

            $(document).on("change", "#attachments-upload", function (e) {
                e.preventDefault();
                let files = $(this).prop("files");
                
                let $label = $("#custom-file-label");
                if (!$label.data("default-text")) {
                    $label.data("default-text", $label.text());
                }

                if (files && files.length > 0) {
                    let fileNames = Array.from(files).map(file => file.name).join(", ");
                    $label.text(fileNames);
                } else {
                    $label.text($label.data("default-text"));
                }
            })

            $(document).on("click", ".organizer-email-mailing-delete", function () {
                let organizer_email_mailing_id = $(this).attr("data-delete-id");
                let confirmMessage = $(this).attr("data-delete-confirm-message");

                if (confirm(confirmMessage)) {
                    $.ajax({
                        type: 'POST',
                        url: "/ajax/organizer_email_mailing/delete",
                        data: {
                            organizer_email_mailing_id
                        }
                    })
                        .done(function (data) {
                             if (data === true) {
                                var $target = $('#organizer-email-mailing-' + organizer_email_mailing_id).remove();
                                $target.fadeOut(1000);
                                popupAlert();

                                setTimeout(function () {
                                    $target.remove();
                                }, 1500);
                            }
                        })
                        .fail(function (data) {
                            if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                                document.location.href = data.responseJSON.redirect_url;
                            }
                        })
                    return true;
                }
                return false;
            });

            $(document).on("click", ".delete-file", function (e) {
                e.preventDefault();
                const confirmMessage = $(this).attr("data-file-delete-confirm-message");

                if (!confirm(confirmMessage)) {
                    return false;
                }

                var $target = $(this).parent().parent();
                $target.fadeOut(1000);
                setTimeout(function () {
                    $target.remove();
                }, 1000);
            })

            if ($(".tinymce").length > 0) {
                let language = $("body").attr("lang");
                let vendorCss = "/public/static/" + $("body").data("vendor-css");
            
                let tinyMceVariables = {
                    selector: '#email-mailings-description-tinymce',
                    height: 300,
                    branding: false,
                    forced_root_block: false,
                    plugins: [
                      'advlist', 'autolink', 'lists', 'link', 'charmap', 'preview',
                      'anchor', 'searchreplace', 'visualblocks', 'fullscreen',
                      'insertdatetime', 'media', 'table', 'help', 'wordcount'
                    ],
                    toolbar: 'undo redo | blocks | ' +
                    'bold italic backcolor | alignleft aligncenter ' +
                    'alignright alignjustify | bullist numlist outdent indent | ' +
                    'removeformat | help',
                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:16px }'
                  };
            
                if (language === "no") {
                  tinyMceVariables.language = "nb_NO";
                }
            
                tinymce.init(tinyMceVariables);
              }
        }
    }
)